import React from 'react';
import { AgentManagement } from '../features/agents';

/**
 * AgentsPage - Admin agents management page
 */
export const AgentsPage: React.FC = () => {
  return <AgentManagement />;
};

export default AgentsPage;
